export type Role = 'ADMIN' | 'EXECUTIVE' | 'CONTRIBUTOR' | 'VENDOR';
export type MfaState = 'ok' | 'verify' | 'enroll';
export type Capability =
  | 'program.read'
  | 'tracker.read'
  | 'plan.manage'
  | 'budget.read'
  | 'reports.manage'
  | 'documents.internal'
  | 'workrecord.manage'
  | 'admin.manage';

export interface ProgramSummary {
  id: string;
  slug: string;
  name: string;
  clientName: string;
  clientShortName: string;
  consultantName: string;
  hasLogo: boolean;
  role: Role;
  title: string | null;
  budgetAccess: boolean;
}

export interface Me {
  user: { id: string; email: string; name: string; mfaEnabled: boolean; recoveryCodesLeft: number };
  mfa: MfaState;
  programs: ProgramSummary[];
}

export interface Program {
  id: string;
  slug: string;
  name: string;
  clientName: string;
  clientShortName: string;
  consultantName: string;
  startDate: string;
  estimatedEndDate: string;
  healthNarrative: string | null;
  timezone: string;
  requireMfaForAll: boolean;
  /** Set once the program's information was destroyed under Agreement §8. */
  purgedAt: string | null;
  logo: { version: number } | null;
  membership: { role: Role; title: string | null; budgetAccess: boolean };
  capabilities: Capability[];
}

export interface Phase {
  id: string;
  number: number;
  name: string;
  objective: string;
  plannedStart: string;
  plannedEnd: string;
  forecastStart: string;
  forecastEnd: string;
  windowNote: string | null;
  healthOverride: 'GREEN' | 'AMBER' | 'RED' | null;
  milestones: Array<{ id: string; name: string; plannedDate: string; forecastDate: string; status: string }>;
  workstreams: Array<{ id: string; name: string }>;
  taskCount: number;
  deliverableCount: number;
}

export const ROLE_LABEL: Record<Role, string> = {
  ADMIN: 'Admin',
  EXECUTIVE: 'Executive',
  CONTRIBUTOR: 'Contributor',
  VENDOR: 'Vendor',
};
